<template>
  <div>
    <v-badge offset-x="0" offset-y="5" :color="options.color">
      <slot />
    </v-badge>
  </div>
</template>
<script>
/**
 * LOADING / OK / INVALID / ERROR ???
 */

export default {
  name: 'StateTab',
  props: {
    state: {
      type: String,
      default: 'UNKNOWN'
    }
  },
  computed: {
    options() {
      const options = { color: 'primary' }
      switch (this.state) {
        case 'ERROR':
          options.color = 'red'
          break
        case 'OK':
          options.color = 'green'
          break
        case 'LOADING':
          options.color = 'yellow'
          break
      }
      return options
    }
  }
}
</script>
